<template>
  <div>
    <alertaMensaje :snackbar="mostrarSnackbar" :mensajeAlertaData="mensajeAlerta" @update-snackbar="hideSnackbar">
    </alertaMensaje>
    <confirmButton :dialogConfirm="mostrarDialogConfirm" :mensajeDialogData="mensajeDialog"
      @update-dialog="confirmarSeleccion" @open-dialog="mostrarDialogConfirm = $event"></confirmButton>
    <v-row v-if="verPreguntasBalotario">
      <v-col cols="12" sm="2" md="2" lg="2">
        <ButtonComp @click="$emit('close')" text-button="Volver" class-color="red"
          icon-but="fas fa-arrow-alt-circle-left" normal-button />
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
        <v-text-field filled disabled primary v-model="parametros.item.desc_nivel" label="NIVEL"
          type="text"></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" md="2" lg="2" class="py-0">
        <v-text-field filled disabled primary v-model="parametros.item.desc_grado" label="GRADO"
          type="text"></v-text-field>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
        <v-text-field filled disabled primary v-model="parametros.item.desc_area" label="ÁREA"
          type="text"></v-text-field>
      </v-col>
      <v-col cols="12" sm="3" md="3" lg="3" class="py-0">
        <v-text-field filled disabled primary v-model="parametros.item.desc_curso" label="CURSO"
          type="text"></v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-alert color="primary" border="left" dense icon="mdi-note-text" dark>BALOTARIO DE PREGUNTAS</v-alert>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" class="d-flex justify-center">
        <ButtonComp @click="verFormulario()" icon-but="fas fa-plus" normal-button text-button="Crear pregunta" />
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" class="d-flex justify-center">
        <ButtonComp @click="verListaSomosHabiles()" icon-but="fas fa-eye" normal-button text-button="Ver somos hábiles"
          class-color="warning" />
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" class="d-flex justify-center">
        <ButtonComp @click="openModalSomosHabiles()" class-color="success" icon-but="fas fa-plus" normal-button
          text-button="Crear somos hábiles" />
      </v-col>
      <v-col cols="12">
        <v-sheet color="transparent" class="" v-if="readyload">
          <v-skeleton-loader class="mx-auto" type="table-thead, table-row-divider@3, table-tfoot"></v-skeleton-loader>
        </v-sheet>
        <!-- v-sortable -->
        <v-data-table v-else :items-per-page="siezPerPage" v-model="selectedItems" :search="searchPreguntas"
          :headers="headerPregunta" :items="arrayPreguntasClase" v-sortable :page.sync="page" hide-default-footer
          @sorted="cambiarOrden($event, parametros.item.id_clase)" show-select sort-by="nombre_tema"
          item-key="idpregunta" class="balotario-datatable elevation-0" @toggle-select-all="selecionaTodosPregunta"
          @page-count="pageCount = $event" @pagination="getPagination">
          <template v-slot:top>

            <v-row>

              <v-col cols="12" sm="12" md="8" lg="8">
                <v-card-title>
                  {{
                    parametros.item.nombre_tema +
                    " : " +
                    parametros.item.nombre_clase
                  }}
                </v-card-title>
              </v-col>

              <v-col cols="12" sm="12" md="4" lg="4" align="right">
                <v-text-field v-model="searchPreguntas" append-icon="fa-search" label="Búsqueda"
                  class="text-center"></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`header.data-table-select`]="{ props, on }">
            <v-btn class="pl-0 " plain small color="dark">
              <v-simple-checkbox :value="props.value" v-on="on" />
              <!-- <v-icon>mdi-arrow-down-thick</v-icon> -->
              <!-- <span>Selecciona</span> -->
            </v-btn>
          </template>


          <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
            <v-simple-checkbox color="red" :value="isSelected" @input="
              select($event),
              seleccionIndividualPregunta($event, item, isSelected, select)
              "></v-simple-checkbox>
          </template>
          <!-- d-none -->
          <template v-slot:[`header.idpregunta`]="{ header }">
            <div class="">
              {{ header.idpregunta }}
            </div>
          </template>
          <!-- d-none -->
          <template v-slot:[`item.idpregunta`]="{ item }">
            <div class="" style="color: #00000000">
              {{ item.idpregunta }}
            </div>
          </template>

          <template v-slot:[`item.titulo`]="{ item }">
            <p class="pt-2" v-html="item.titulo"></p>
          </template>

          <template v-slot:[`item.dificultad`]="{ item }">
            <v-chip v-if="item.dificultad == 0" :color="`blue`" class="ml-0 mr-2 black--text" label small>
              FACIL
            </v-chip>

            <v-chip v-if="item.dificultad == 1" :color="`success`" text-color="white" class="ml-0 mr-2 black--text"
              label small>
              INTERMEDIO
            </v-chip>

            <v-chip v-if="item.dificultad == 2" :color="`red`" class="ml-0 mr-2 black--text" label small>
              DIFICIL
            </v-chip>
          </template>

          <template v-slot:[`item.tipo`]="{ item }">
            <v-chip v-if="item.tipo == 'res_uni'" :color="`blue lighten-4`" class="ml-0 mr-2 black--text" label small>
              Respuesta Única
            </v-chip>

            <v-chip v-if="item.tipo == 'res_mul'" :color="`green lighten-4`" class="ml-0 mr-2 black--text" label small>
              Respuesta Múltiple
            </v-chip>

            <v-chip v-if="item.tipo == 'ver_fal'" :color="`red lighten-4`" class="ml-0 mr-2 black--text" label small>
              Verdadero - Falso
            </v-chip>
          </template>

          <template v-slot:[`item.orden`]="{ item }">
            <strong>{{ item.orden }}</strong>
          </template>

          <template v-slot:[`item.ver`]="{ item }">
            <v-tooltip bottom color="#1b1b1b">
              <template v-slot:activator="{ on }">
                <v-btn :loading="loading[item.idpregunta]" :disabled="loading[item.idpregunta]" v-on="on"
                  class="btn_editar px-0 mx-0" fab x-small @click="editarFormulario(item)">
                  <v-icon>fa-pencil-alt</v-icon>
                </v-btn>
              </template>
              <span>EDITAR</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <v-row>
          <v-col cols="12" sm="2" md="2" lg="2">
            <v-select class="ml-4 pt-6" v-model="siezPerPage" :items="itemsPerPage" label="Ítems por página"
              @change="siezPerPage = parseInt($event, 10)">
            </v-select>
          </v-col>
          <v-col cols="12" sm="10" md="10" lg="10">
            <div class="d-flex justify-end pt-2">
              <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbarGlobal" :color="colorsnackbarGlobal" multi-line :timeout="timeout" top>
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>mdi-alert-circle-outline</v-icon>
        <v-layout column>
          <div>
            <strong> {{ textAlertGlobal }} </strong>
          </div>
          <div>
            <ul v-for="(item, i) in SubtextAlertGlobal" :key="i">
              <li>{{ item }}</li>
            </ul>
          </div>
        </v-layout>
      </v-layout>
      <!-- <template v-slot:action="{ attrs }">
        <v-btn
          color="black"
          text
          v-bind="attrs"
          @click="snackbarGlobal = false"
        >
          Cerrar
        </v-btn>
      </template> -->
    </v-snackbar>

    <component :is="compName" :estadoComp="estadoComponente" :parametros="parametroComp" @close="CloseModal"
      @closeBottomShet="CloseBottomShet">
    </component>
  </div>
</template>
<script>
// import axios, mapActions, mapGetters { API_URL } from "@/helpers/axios";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import axios from "@/helpers/axios";
// import { mapState, mapMutations } from "vuex";
import Sortable from "sortablejs";
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
export default {
  name: "balotarioSomosHabilites",
  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },
  components: {
    ButtonComp,
    alertaMensaje: () =>
      import("../../../SimuladorExamenes/components/Co-alertaMensaje.vue"),
    ResetButton: () =>
      import("../../../SimuladorExamenes/components/Co-resetBtn.vue"),
    confirmButton: () =>
      import("../../../SimuladorExamenes/components/Co-ComfirMensaje.vue"),
    formularioPregunta: () =>
      import(
        "../../../SimuladorExamenes/manager/componentes/formularioPregunta.vue"
      ),
    listaSomosHabiles: () => import("./listaSomosHabiles.vue"),
  },
  data: () => ({
    readyload: false, // VARIABLE SKELETON
    datoLogin: sessionStorage, // VARIABLE OBTENER COKIES DEL STORAGE
    usedCodes: [], // VARIABLE GENERA CODIGOS ALETARIOS PARA EXAMEN SOMOS HABILES
    snackbarGlobal: false, //COMPONENTE ALERTA GLOBA
    colorsnackbarGlobal: "green", //COMPONENTE ALERTA GLOBA
    textAlertGlobal: "", //COMPONENTE ALERTA GLOBA
    SubtextAlertGlobal: [], //COMPONENTE ALERTA GLOBA
    selectedItems: [], // VARIABLE PREGUNTAS SELECCIONADAS
    idclase: null,
    detallePerfil: "",
    timeout: 2000, //COMPONENTE ALERTA CONFIRMACION
    mostrarSnackbar: false, //COMPONENTE ALERTA CONFIRMACION
    mensajeAlerta: "", //COMPONENTE ALERTA CONFIRMACION
    mensajeDialog: "", //COMPONENTE DIALOGO DE CONFIRMACION
    mostrarDialogConfirm: false, //COMPONENTE DIALOGO DE CONFIRMACION
    arrayPreguntaSelected: [], //PREGUNTAS SELECCIONADAS
    compName: null, //VARIABLES PROPS PRA EL CAMBIO DE VISTA
    estadoComponente: true, //VARIABLES PROPS PRA EL CAMBIO DE VISTA
    parametroComp: [], //VARIABLES PROPS PRA EL CAMBIO DE VISTA
    verPreguntasBalotario: true, //VARIABLE VALIDADOR PARA MOSTRAR VISTA GENERAL
    paginationData: {}, //METODO OBTENER DATOS DE PAGINACION
    page: 1, // VARIABLES DE PAGINACION
    pageCount: 0, // VARIABLES DE PAGINACION
    siezPerPage: 10, // VARIABLES DE PAGINACION
    itemsPerPage: [5, 10, 15], // VARIABLES DE PAGINACION
    select_nivel: "", // CAMPOS DE INFORMACION
    select_grado: "", // CAMPOS DE INFORMACION
    select_area: "", // CAMPOS DE INFORMACION
    select_curso: "", // CAMPOS DE INFORMACION
    nombre_unidad: "", // CAMPOS DE INFORMACION
    loading: [],
    searchPreguntas: "", // VARIABLE DATATABLE
    arrayPreguntasClase: [], // VARIABLE DATATABLE ITEMS
    headerPregunta: [
      // VARIABLE DATATABLE HEADERS
      { text: "ID", value: "idpregunta", sortable: false, class: 'secondary black--text' },
      { text: "TITULO", value: "titulo", sortable: false, class: 'secondary black--text' },
      { text: "DIFICULTAD", value: "dificultad", sortable: false, class: 'secondary black--text' },
      { text: "ORDEN", value: "orden", sortable: false, class: 'secondary black--text' },
      { text: "TIPO", value: "tipo", sortable: false, class: 'secondary black--text' },
      { text: "EDITAR", value: "ver", sortable: false, class: 'secondary black--text' },
    ],
  }),
  mounted() {
    this.listarPreguntasPorClases();
  },
  watch: {
    estadoComp() {
      if (this.estadoComp) {
        this.verPreguntasBalotario = true;
        this.listarPreguntasPorClases();
      } else {
        this.verPreguntasBalotario = false;
      }
    },
  },
  directives: {
    sortable: {
      bind(el, binding, vnode) {
        const options = {
          animation: 150,
          onUpdate: function (event) {
            vnode.child.$emit("sorted", event);
          },
        };
        Sortable.create(el.getElementsByTagName("tbody")[0], options);
      },
    },
  },
  methods: {
    async confirmarSeleccion(e) {
      const me = this;
      console.log(me.arrayPreguntaSelected);
      // me.validaDialogConfirm = e;
      if (e == true) {

        console.log('estos llega o no llega', this.parametros.item.id_clase);

        me.crearExamenSomosHabiles(this.parametros.item.id_clase);
      }
    },
    async openModalSomosHabiles() {
      const me = this;
      if (me.arrayPreguntaSelected.length > 0) {
        me.mensajeDialog = "¿ Estás seguro de crear Somos Hábiles ?";
        me.mostrarDialogConfirm = true;
      } else {
        me.snackbarGlobal = true;
        me.colorsnackbarGlobal = "red";
        // me.textAlertGlobal = "Debe seleccionar obligatoriamente seis preguntas:";
        me.textAlertGlobal = "Debe seleccionar al menos una pregunta";
        me.SubtextAlertGlobal = [
          // 'Dos de tipo "Respuesta única"',
          // 'Dos de tipo "Respuesta múltiple"',
          // 'Dos de tipo "Verdadero - falso"'
        ];
      }
    },
    generateRandomCode(length) {
      // debugger;
      let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let code = "";

      while (code.length < length) {
        let randomChar = characters.charAt(
          Math.floor(Math.random() * characters.length)
        );
        code += randomChar;
      }

      if (this.usedCodes.includes(code)) {
        // If the code is already used, generate a new one recursively
        return this.generateRandomCode(length);
      }

      this.usedCodes.push(code);
      return code;
    },
    async crearExamenSomosHabiles(clases) {
      const me = this;
      let ClasesArray = [];
      let Usuarios = [];
      ClasesArray[0] = clases;
      Usuarios[0] = me.datoLogin.id;
      try {
        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorRespuestas/simuladorR/listares/" +
          ClasesArray
        );
        if (response.data.length != 0) {
          NProgress.configure({ minimum: 0.1, trickleSpeed: 50 });
          NProgress.start();

          let map = new Map();
          response.data.forEach((currentValue) => {
            map.has(currentValue.idpregunta)
              ? map.get(currentValue.idpregunta).push({
                estado: currentValue.estado,
                pregunta: currentValue.pregunta,
                idrespuesta: currentValue.idrespuesta,
                idtema: currentValue.idtema,
                orden: currentValue.orden,
                respuesta: currentValue.respuesta,
                valor_respuesta: currentValue.valor_respuesta,
              })
              : map.set(currentValue.idpregunta, [
                {
                  estado: currentValue.estado,
                  pregunta: currentValue.pregunta,
                  idrespuesta: currentValue.idrespuesta,
                  idtema: currentValue.idtema,
                  orden: currentValue.orden,
                  respuesta: currentValue.respuesta,
                  valor_respuesta: currentValue.valor_respuesta,
                },
              ]);
          });

          const arr = Array.from(map, ([idpregunta, respuestas]) => {
            return { idpregunta, respuestas };
          });
          let preguntasSomosHabiles = arr.filter((pregunta) =>
            me.arrayPreguntaSelected.includes(pregunta.idpregunta)
          );

          console.log(preguntasSomosHabiles);
          await me.guardarDetalleExamen(
            preguntasSomosHabiles,
            clases,
            Usuarios
          );
        } else {
          // setTimeout(async () => {
          //   // if (!clases.isArray) {
          //   //   me.loadingPregunta.splice(
          //   //     this.loadingPregunta.indexOf(clases),
          //   //     1
          //   //   );
          //   // }
          //   // me.snackbarAlert = true;
          //   // me.colorsnackbarAlert = "red";
          //   // me.SnackbarTextAlert = "No hay preguntas para esta clase";
          //   // me.dialogCreaSimuladorMasivo = false;
          //   // me.itemAlumnosSelected = [];
          // }, 500);
        }
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      } finally {
        me.verListaSomosHabiles()
      }
    },
    async guardarDetalleExamen(itemRespuestas, clases, usuarios) {
      const me = this;

      itemRespuestas.forEach((obj) => {
        obj.idexamen = "";
        obj.valor_pregunta = false;
        obj.respuestas;
      });

      try {
        let fecha = new Date();
        let dia = fecha.getDay();
        let milisegundos = dia + fecha.getMilliseconds();
        let codigoRan = me.generateRandomCode(6);

        console.log(me.detallePerfil);

        const respuesta = await axios.post(
          "/simulador/simuladorExamen/simuladorExamenes/simuladorE/registraExamen",
          {
            usuarios: usuarios,
            perfil: me.detallePerfil,
            descripcion: "",
            observacion: "",
            codigo: `EX${milisegundos}-${codigoRan}`,
            calificacion: "",
            estado: true,
            idautor: me.datoLogin.id,
            tipo_muestra: "EVALUACIÓN",
            clases: clases,
            prioridad: 0,
            id_ano_lectivo: +me.datoLogin.id_ano_lectivo,
            id_colegio: +me.datoLogin.id_colegio,
            respuestas: itemRespuestas,
          }
        );
        console.log(respuesta);
        me.mostrarSnackbar = true;
        me.mensajeAlerta = "Se ha creado el examen SOMOS HÁBILES";
        me.mostrarDialogConfirm = false;
        NProgress.done();

        me.arrayPreguntaSelected = [];
        me.selectedItems = [];
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    selecionaTodosPregunta(event) {

      // me.idclase = this.parametros.item.id_clase;
      const me = this;
      if (event.value == true) {
        me.arrayPreguntaSelected = [];
        let arrayitems = event.items;
        arrayitems.forEach((element) => {
          me.arrayPreguntaSelected.push(element.idpregunta);
        });
      } else {
        me.arrayPreguntaSelected = [];
      }
    },
    seleccionIndividualPregunta(event, item) {
      const me = this;
      // me.idclase = item.idclase;
      if (event === true) {
        me.arrayPreguntaSelected.push(item.idpregunta);
      } else {
        let index = me.arrayPreguntaSelected.indexOf(item.idpregunta);
        if (index !== -1) {
          me.arrayPreguntaSelected.splice(index, 1);
        }
      }
      console.log(me.arrayPreguntaSelected);
    },
    getPagination(pagination) {
      const me = this;
      me.paginationData = pagination;
    },
    cambiarOrden(event, idtema) {
      const me = this;
      console.log(idtema);
      const ordenNew = event.newIndex + me.paginationData.pageStart + 1;
      const movedItem = me.arrayPreguntasClase.splice(
        event.oldIndex + me.paginationData.pageStart,
        1
      )[0];
      me.arrayPreguntasClase.splice(
        event.newIndex + me.paginationData.pageStart,
        0,
        movedItem
      );
      me.arrayPreguntasClase[
        event.newIndex + me.paginationData.pageStart
      ].orden = ordenNew;

      for (let i = 0; i < event.target.children.length; i++) {
        me.modificarOrdenPreguntas(
          idtema,
          event.target.children[i].children[1].innerText,
          me.paginationData.pageStart + i + 1
        );
        let numit = Number(me.paginationData.pageStart + i + 1 - 1);
        // console.log(numit);
        me.arrayPreguntasClase[numit].orden =
          me.paginationData.pageStart + i + 1;
      }
      me.mostrarSnackbar = true;
      me.mensajeAlerta = "Orden Cambiado";
    },
    async modificarOrdenPreguntas(idtema, idpregunta, newIndex) {
      // const me = this;
      try {
        await axios.put(
          "/simulador/simuladorExamen/simuladorPreguntas/simuladorP/actualizaIndice/" +
          idtema,
          {
            orden_new: newIndex,
            idpregunta: idpregunta,
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerPerfil() {
      const me = this;
      try {
        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorExamenes/simuladorE/capturePerfil/" +
          me.datoLogin.id_perfil
        );
        //console.log(response.data["descripcion_perfil"]);
        me.detallePerfil = response.data["descripcion_perfil"];
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
      }
    },
    async listarPreguntasPorClases() {
      const me = this;
      me.obtenerPerfil();
      me.readyload = true;
      me.arrayPreguntasClase = [];
      try {
        const response = await axios.get(
          "/simulador/simuladorExamen/simuladorPreguntas/simuladorP/lista/" +
          this.parametros.item.id_clase
        );
        me.arrayPreguntasClase = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        me.readyload = false;
      }
    },
    editarFormulario(item) {
      const me = this;
      me.arrayPreguntaSelected = [];
      me.selectedItems = [];
      me.verPreguntasBalotario = false;
      me.parametroComp = {
        item,
        event: "edit_gestor",
        items: me.parametros,
        cantidad: me.arrayPreguntasClase,
      };
      me.compName = "formularioPregunta";
      me.estadoComponente = true;
    },
    verFormulario() {
      const me = this;
      me.arrayPreguntaSelected = [];
      me.selectedItems = [];
      me.verPreguntasBalotario = false;
      me.parametroComp = {
        event: "view_gestor",
        items: me.parametros,
        cantidad: me.arrayPreguntasClase,
      };
      me.compName = "formularioPregunta";
      me.estadoComponente = true;
    },
    verListaSomosHabiles() {
      const me = this;
      me.arrayPreguntaSelected = [];
      me.selectedItems = [];
      // me.verPreguntasBalotario = false;
      me.parametroComp = {
        event: "view_listaSomosHabiles",
        items: me.parametros,
        cantidad: me.arrayPreguntasClase,
      };
      me.compName = "listaSomosHabiles";
      me.estadoComponente = true;
    },
    hideSnackbar(e) {
      this.mostrarSnackbar = e;
    },
    CloseModal() {
      this.estadoComponente = false;
      this.verPreguntasBalotario = true;
      this.listarPreguntasPorClases();
    },
    CloseBottomShet() {
      this.estadoComponente = false;
    },
  },
};
</script>
<style scoped>

::v-deep thead th:first-child {
  background-color: #bdbdbd !important; /* Cambia este color al que quieras */
}

.balotario-datatable {
  overflow-x: hidden !important;
}


#nprogress .bar {
  height: 3px;
}
</style>
